<div class="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
  <p class="text-sm text-ink/60">Home / Shop</p>
  <div class="mt-2 flex flex-wrap items-baseline justify-between gap-4">
    <h1 class="font-display text-3xl font-semibold text-ink">All Saddles</h1>
    @if (result(); as result) {
      <p class="text-sm text-ink/60">{{ result.total }} saddles</p>
    }
  </div>

  @if (activeFilterEntries().length) {
    <div class="mt-4 flex flex-wrap items-center gap-2">
      @for (entry of activeFilterEntries(); track entry.field + entry.value) {
        <button
          type="button"
          class="cursor-pointer flex items-center gap-1.5 rounded-full border border-line bg-white px-3 py-1 text-xs text-ink hover:border-tan"
          (click)="toggleFilter(entry.field, entry.value)"
        >
          {{ entry.value }}
          <span aria-hidden="true">&times;</span>
        </button>
      }
      <button
        type="button"
        class="cursor-pointer text-xs font-medium text-tandark hover:underline"
        (click)="clearAll()"
      >
        Clear all
      </button>
    </div>
  }

  <div class="mt-6 grid grid-cols-1 gap-8 lg:grid-cols-[272px_1fr]">
    <aside class="hidden lg:block">
      <div
        class="sticky top-24 flex max-h-[calc(100dvh-7rem)] flex-col gap-6 overflow-y-auto pr-1 pb-4"
      >
        <ng-container *ngTemplateOutlet="filterPanels" />
      </div>
    </aside>

    <section>
      <div class="mb-4 flex items-center justify-between gap-3">
        <button
          type="button"
          class="cursor-pointer inline-flex items-center gap-2 rounded-lg border border-line bg-white px-3 py-1.5 text-sm font-medium text-ink transition hover:border-tan lg:hidden"
          (click)="openMobileFilters()"
        >
          <svg
            class="h-4 w-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            aria-hidden="true"
          >
            <path d="M4 6h16M7 12h10M10 18h4" stroke-linecap="round" />
          </svg>
          Filters
          @if (activeFilterEntries().length) {
            <span
              class="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-forest px-1.5 text-[11px] font-semibold text-cream"
            >
              {{ activeFilterEntries().length }}
            </span>
          }
        </button>

        <label class="ml-auto flex items-center gap-2 text-sm text-ink/70">
          Sort by
          <select
            class="rounded-lg border border-line bg-white px-2 py-1.5 text-sm"
            (change)="setSort($any($event.target).value)"
          >
            <option
              value="newest"
              [selected]="query().sort !== 'price_asc' && query().sort !== 'price_desc'"
            >
              Newest
            </option>
            <option value="price_asc" [selected]="query().sort === 'price_asc'">
              Price: Low to High
            </option>
            <option value="price_desc" [selected]="query().sort === 'price_desc'">
              Price: High to Low
            </option>
          </select>
        </label>
      </div>

      @if (result(); as result) {
        @if (result.items.length) {
          <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 xl:grid-cols-3">
            @for (product of result.items; track product.id) {
              <app-product-card [product]="product" [priority]="$index === 0" />
            }
          </div>

          @if (totalPages() > 1) {
            <div class="mt-8 flex items-center justify-center gap-2">
              @for (p of pageNumbers(); track p) {
                <button
                  type="button"
                  class="cursor-pointer h-9 w-9 rounded-full text-sm"
                  [class.bg-forest]="result.page === p"
                  [class.text-cream]="result.page === p"
                  [class.text-ink]="result.page !== p"
                  (click)="goToPage(p)"
                >
                  {{ p }}
                </button>
              }
            </div>
          }
        } @else {
          <div class="rounded-xl border border-line bg-white py-24 text-center">
            <p class="font-display text-lg text-ink">No saddles match those filters</p>
            <button
              type="button"
              class="cursor-pointer mt-3 text-sm font-medium text-forest hover:underline"
              (click)="clearAll()"
            >
              Clear all filters
            </button>
          </div>
        }
      }
    </section>
  </div>
</div>

@if (mobileFiltersOpen()) {
  <div
    class="fixed inset-0 z-50 flex flex-col bg-ink/40 lg:hidden"
    role="dialog"
    aria-modal="true"
    aria-labelledby="mobile-filters-title"
    (click)="closeMobileFilters()"
  >
    <div
      class="mt-auto flex max-h-[92dvh] w-full flex-col rounded-t-2xl bg-cream shadow-xl"
      (click)="$event.stopPropagation()"
    >
      <div class="flex shrink-0 items-center justify-between border-b border-line px-4 py-4">
        <h2 id="mobile-filters-title" class="font-display text-xl font-semibold text-ink">
          Filters
        </h2>
        <button
          type="button"
          class="cursor-pointer flex h-9 w-9 items-center justify-center rounded-full text-ink/60 transition hover:bg-creamdark hover:text-ink"
          aria-label="Close filters"
          (click)="closeMobileFilters()"
        >
          <span class="text-2xl leading-none" aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="flex-1 space-y-4 overflow-y-auto px-4 py-4">
        <ng-container *ngTemplateOutlet="filterPanels" />
      </div>

      <div
        class="flex shrink-0 gap-3 border-t border-line bg-cream px-4 py-4 pb-[max(1rem,env(safe-area-inset-bottom))]"
      >
        <button
          type="button"
          class="cursor-pointer flex-1 rounded-full border border-line px-4 py-2.5 text-sm font-medium text-ink transition hover:bg-creamdark"
          (click)="clearAll()"
        >
          Clear all
        </button>
        <button
          type="button"
          class="cursor-pointer flex-[2] rounded-full bg-forest px-4 py-2.5 text-sm font-medium text-cream transition hover:opacity-90"
          (click)="closeMobileFilters()"
        >
          @if (result(); as result) {
            Show {{ result.total }} {{ result.total === 1 ? 'saddle' : 'saddles' }}
          } @else {
            Show results
          }
        </button>
      </div>
    </div>
  </div>
}

<ng-template #filterPanels>
  <details open class="rounded-xl border border-line bg-white p-4">
    <summary class="cursor-pointer text-sm font-semibold text-ink">Discipline</summary>
    <div class="mt-3 flex flex-col gap-2">
      @for (d of disciplines(); track d.id) {
        <label class="flex items-center justify-between text-sm text-ink/80">
          <span class="flex items-center gap-2">
            <input
              type="checkbox"
              [checked]="isActive('discipline', d.slug)"
              (change)="toggleFilter('discipline', d.slug)"
            />
            {{ d.name }}
          </span>
          <span class="text-xs text-ink/40">{{ countFor('discipline', d.slug) }}</span>
        </label>
      }
    </div>
  </details>

  <details class="rounded-xl border border-line bg-white p-4">
    <summary class="cursor-pointer text-sm font-semibold text-ink">Brand</summary>
    <div class="mt-3 flex max-h-56 flex-col gap-2 overflow-y-auto">
      @for (b of brands(); track b.id) {
        <label class="flex items-center justify-between text-sm text-ink/80">
          <span class="flex items-center gap-2">
            <input
              type="checkbox"
              [checked]="isActive('brand', b.slug)"
              (change)="toggleFilter('brand', b.slug)"
            />
            {{ b.name }}
          </span>
          <span class="text-xs text-ink/40">{{ countFor('brand', b.slug) }}</span>
        </label>
      }
    </div>
  </details>

  <details class="rounded-xl border border-line bg-white p-4">
    <summary class="cursor-pointer text-sm font-semibold text-ink">Colour</summary>
    <div class="mt-3 flex flex-wrap gap-2">
      @for (c of colours(); track c.id) {
        <button
          type="button"
          class="cursor-pointer flex h-8 w-8 items-center justify-center rounded-full border-2"
          [style.borderColor]="isActive('colour', c.name) ? 'var(--color-forest)' : 'transparent'"
          (click)="toggleFilter('colour', c.name)"
          [attr.aria-label]="c.name"
          [attr.title]="c.name + ' (' + countFor('colour', c.name) + ')'"
        >
          <span class="h-6 w-6 rounded-full" [style.backgroundColor]="c.hexSwatch"></span>
        </button>
      }
    </div>
  </details>

  <details class="rounded-xl border border-line bg-white p-4">
    <summary class="cursor-pointer text-sm font-semibold text-ink">Tree Width</summary>
    <div class="mt-3 flex flex-wrap gap-2">
      @for (tw of treeWidths; track tw) {
        <button
          type="button"
          class="cursor-pointer rounded-full border px-3 py-1 text-xs"
          [class.border-forest]="isActive('treeWidth', tw)"
          [class.bg-forest]="isActive('treeWidth', tw)"
          [class.text-cream]="isActive('treeWidth', tw)"
          [class.border-line]="!isActive('treeWidth', tw)"
          (click)="toggleFilter('treeWidth', tw)"
        >
          {{ formatCondition(tw) }} ({{ countFor('treeWidth', tw) }})
        </button>
      }
    </div>
  </details>

  <details class="rounded-xl border border-line bg-white p-4">
    <summary class="cursor-pointer text-sm font-semibold text-ink">Material</summary>
    <div class="mt-3 flex flex-col gap-2">
      @for (m of materials; track m) {
        <label class="flex items-center justify-between text-sm text-ink/80">
          <span class="flex items-center gap-2">
            <input
              type="checkbox"
              [checked]="isActive('material', m)"
              (change)="toggleFilter('material', m)"
            />
            {{ formatCondition(m) }}
          </span>
          <span class="text-xs text-ink/40">{{ countFor('material', m) }}</span>
        </label>
      }
    </div>
  </details>

  <details class="rounded-xl border border-line bg-white p-4">
    <summary class="cursor-pointer text-sm font-semibold text-ink">Condition</summary>
    <div class="mt-3 flex flex-col gap-2">
      @for (c of conditions; track c) {
        <label class="flex items-center justify-between text-sm text-ink/80">
          <span class="flex items-center gap-2">
            <input
              type="checkbox"
              [checked]="isActive('condition', c)"
              (change)="toggleFilter('condition', c)"
            />
            {{ formatCondition(c) }}
          </span>
          <span class="text-xs text-ink/40">{{ countFor('condition', c) }}</span>
        </label>
      }
    </div>
  </details>

  <details class="rounded-xl border border-line bg-white p-4">
    <summary class="cursor-pointer text-sm font-semibold text-ink">Location</summary>
    <div class="mt-3 flex flex-col gap-2">
      @for (s of states; track s) {
        <label class="flex items-center justify-between text-sm text-ink/80">
          <span class="flex items-center gap-2">
            <input
              type="checkbox"
              [checked]="isActive('state', s)"
              (change)="toggleFilter('state', s)"
            />
            {{ s }}
          </span>
          <span class="text-xs text-ink/40">{{ countFor('state', s) }}</span>
        </label>
      }
    </div>
  </details>
</ng-template>
